import { render, staticRenderFns } from "./carrier-add.vue?vue&type=template&id=747abdf3&scoped=true"
import script from "./carrier-add.vue?vue&type=script&lang=js"
export * from "./carrier-add.vue?vue&type=script&lang=js"
import style0 from "./carrier-add.vue?vue&type=style&index=0&id=747abdf3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747abdf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('747abdf3')) {
      api.createRecord('747abdf3', component.options)
    } else {
      api.reload('747abdf3', component.options)
    }
    module.hot.accept("./carrier-add.vue?vue&type=template&id=747abdf3&scoped=true", function () {
      api.rerender('747abdf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/carrier-add.vue"
export default component.exports